module.exports = __webpack_public_path__ + "media/app/components/global/logo-b2b4bcf2434da4cb46b51aa4e93751ac.png";